import React, { FC, MouseEvent } from 'react'

import { useDispatch } from 'react-redux'
import styled, { RuleSet } from 'styled-components'

import { WithDataName } from 'common/types'
import { Colors } from 'common-constants/colors'
import {
  shareContentPhotoViewerTooltipId,
  SharingType,
} from 'components/block/SharingContent/SharingContent.constant'
import { SharingContent } from 'components/block/SharingContent/SharingContentIndex'
import { photoButtonCss } from 'components/page/PhotoViewer/Panel/Panel.styled'
import { SharingContentSvg } from 'components/presentational/svg/SharingContentSvg'
import {
  DarkLight,
  DarkLightStyled,
} from 'components/presentational/theme/DarkLight'
import { fullStopPropagation } from 'functions/fullStopPropagation'
import { push } from 'functions/router'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { useTooltip } from 'hooks/useTooltip'

export const ShareButton: FC<
  {
    type: SharingType
    contentId: number
    profileId: string
    alignmentStyle: RuleSet<object>
  } & DarkLight &
    WithDataName
> = ({ type, contentId, profileId, alignmentStyle, dark, ...rest }) => {
  const dispatch = useDispatch()
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )
  const [tooltipState, toggleTooltipState] = useTooltip(
    shareContentPhotoViewerTooltipId
  )
  const authorizationPath = useAuthorizationPath()

  const handleClick = (event: MouseEvent) => {
    if (authorized) {
      fullStopPropagation(event)
      event.preventDefault()
      toggleTooltipState(event)
    } else {
      dispatch(push(authorizationPath))
    }
  }

  return (
    <>
      <InternalButton
        href={authorizationPath}
        onClick={handleClick}
        $dark={dark}
        data-name={rest['data-name']}
        role="button"
        tabIndex={0}
      >
        <SharingContentSvg stroke={dark ? Colors.white : Colors.link} />
      </InternalButton>
      {tooltipState && (
        <SharingContent
          type={type}
          contentId={contentId}
          profileId={Number(profileId)}
          alignmentStyleCss={alignmentStyle}
        />
      )}
    </>
  )
}

const InternalButton = styled.a<DarkLightStyled>`
  ${photoButtonCss};
  width: 40px;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  z-index: 1;
`
